site.scrollspy = {
	init: function () {
		if ($('.sustainability__view').length === 0) {
			return;
		}

		site.scrollspy.fixScrollBehaviorCss();
		site.scrollspy.scrollOnLoad();
		site.scrollspy.initSpyscroll();
		site.scrollspy.onActivate();
	},

	fixScrollBehaviorCss: function() {
		$('html').css('scroll-behavior', 'initial');
	},

	scrollOnLoad: function() {
		if (!site.device.isTouch()) {
			$(window).load(function () {
				if (location.hash) {
					var $elm = $(location.hash),
						headerHeight = $('header').height(),
						offset = -40;
					$('html,body').animate({scrollTop: $elm.offset().top - headerHeight + offset}, 'linear');
				}
			});
		}
	},

	initSpyscroll: function() {
		var $body = $('body');
		$body.scrollspy({target: '#scrollSpy', offset: 400});

		$('a', '.anchorMenu').on('click', function (e) {
			e.preventDefault();
			var headerHeight = $('header').height(),
				toTop = $($(this).attr('href')).offset().top,
				offset = -40;
			$('html, body').animate({scrollTop: toTop - headerHeight + offset}, 'linear');
			site.scrollspy.setHash($(this).attr('href'))
		});
	},

	setHash: function(hash) {
		if (location.hash === hash) {
			return;
		}

		var scrollTop = $(window).scrollTop();
		location.hash = hash;
		window.scrollTo(0, scrollTop);
		var $anchorMenu = $('.anchorMenu');
		$('li', $anchorMenu).removeClass('selected');
		$('a[href=' + hash + ']', $anchorMenu).parent().addClass('selected');
	},

	removeHash: function() {
		var scrollTop = $(window).scrollTop();
		location.hash = '';
		window.scrollTo(0, scrollTop);
	},

	onActivate: function() {
		var $sidebar = $('#scrollSpy');

		if (!site.device.isTouch()) {
			$sidebar.on('activate.bs.scrollspy', function () {
				let $active = $('.active a', $sidebar);
				site.scrollspy.setHash($active.attr('href'));
			})

			window.onscroll = function () {
				if (window.pageYOffset < 300) {
					site.scrollspy.removeHash();
				}
			};
		}
	}
};

site.inits.push('site.scrollspy.init()');
